var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('el-form-item',{ref:_vm.field.FIELD_ID,class:_vm.itemClass,attrs:{"id":_vm.field.FIELD_ID,"prop":_vm.field.FIELD_ID}},[_c('div',{staticClass:"button"},[_c('el-button',{staticClass:"field-button",attrs:{"disabled":_vm.isDisabled},domProps:{"innerHTML":_vm._s(_vm.fieldButtonTxt || '确认')},on:{"click":_vm.clickButton}})],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6659f687","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/style-rem-loader??ref--1!./src/components/preEntry/normalButtonItem.vue
// module id = 1088
// module chunks = 2